// Phase 41 (D3a / D4) — the ONE client-folder opener, shared by:
//   • the CDD section's linked-clients panel (CddCaseSection),
//   • the client record (CddClientSection), and
//   • the Documents section's per-client "Client file" rows (CaseDocumentsSection).
//
// Client.clientRootFolder stores a PATH, not a webUrl. The webUrl is resolved
// live — and RE-GATED — server-side by the shared browse resolver
// (GET /api/auth/microsoft/browse?mode=resolve): it returns a webUrl only when
// the stored path matches AND the viewer passes the per-client read-gate
// (clientFolderGate). This is deliberately NOT a second resolver — do not add
// one; open through here. Extracted verbatim from CddCaseSection so all three
// surfaces share a single implementation.
import { api } from "../api";

export async function openClientFolder(
  clientId: number,
  path: string,
  t?: (k: string, o?: any) => string,
) {
  const tr = (k: string, fb: string) =>
    typeof t === "function" ? t(k, { fallback: fb }) : fb;
  try {
    // 174 §1.2 — through api(), which sends BOTH credentials: the lx:token
    // Bearer AND the lx_session cookie. The bare fetch that stood here sent
    // the cookie alone, so a browser holding only the token answered 401
    // auth.missing_token. api() supplies the /api prefix (API_URL).
    const j = (await api.get(
      "/auth/microsoft/browse?path=" +
        encodeURIComponent(path) +
        "&clientId=" +
        clientId +
        "&mode=resolve",
    )) as { currentFolder?: { webUrl?: string } };
    if (j.currentFolder?.webUrl) {
      window.open(j.currentFolder.webUrl, "_blank");
      return;
    }
    // 176 §1.2(d) — the second of the two failure toasts, and the sentence is
    // APPENDED (a toast carries no icon). A folder that will not open is
    // exactly when a reader suspects the rename they just did: the link points
    // at the folder, not at its name, so a rename is never the cause.
    window.lxToast?.(
      "⚠ " +
        tr("toast.couldnt_open_folder", "Couldn't open folder") +
        " " +
        tr("folder.permanence_hint", "The link points at the folder, not at its name."),
    );
  } catch (e) {
    window.lxToast?.("⚠ " + ((e as any).message || "Open failed"));
  }
}
